import { supabase } from "../supabase";
import type { Program, ProgramLesson } from "../types";

interface ProgramRow {
  id: string;
  school_id: string;
  name: string;
  total_lessons: number;
}

interface ProgramLessonRow {
  program_id: string;
  position: number;
  name: string;
}

function mapProgram(r: ProgramRow): Program {
  return {
    id: r.id,
    schoolId: r.school_id,
    name: r.name,
    totalLessons: r.total_lessons,
  };
}

function mapProgramLesson(r: ProgramLessonRow): ProgramLesson {
  return { programId: r.program_id, position: r.position, name: r.name };
}

export async function listBySchool(schoolId: string): Promise<Program[]> {
  const { data, error } = await supabase
    .from("programs")
    .select("id, school_id, name, total_lessons")
    .eq("school_id", schoolId);
  if (error) throw error;
  return (data as ProgramRow[]).map(mapProgram);
}

export async function lessonsForPrograms(programIds: string[]): Promise<ProgramLesson[]> {
  if (!programIds.length) return [];
  const { data, error } = await supabase
    .from("program_lessons")
    .select("program_id, position, name")
    .in("program_id", programIds)
    .order("position", { ascending: true });
  if (error) throw error;
  return (data as ProgramLessonRow[]).map(mapProgramLesson);
}
